import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-regular-svg-icons";
import ModalDocumentoPastaCriar from "components/modal/documentos/pasta/ModalDocumentoPastaCriar";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import { useEffect, useRef, useState } from "react";
import DocumentoPastaService from "service/documentos/DocumentoPastaService";
import "./style/DocumentoPastaPage.css";
import { IconLookup } from "@fortawesome/fontawesome-svg-core";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import ModalDocumentoPastaEditar from "components/modal/documentos/pasta/ModalDocumentoPastaEditar";
import Documento from "model/documentos/Documento";
import ModalDocumentoMover from "components/modal/documentos/pasta/ModalDocumentoMover";
import { useToastContext } from "components/alert/ToastContext";

const documentoPastaService = new DocumentoPastaService();
export default function DocumentoPastaLixeiraPage() {
    const [pasta, setPasta] = useState<DocumentoPasta | null>(null);
    const [pastaAlterar, setPastaAlterar] = useState<{ visible: boolean, pasta: DocumentoPasta | null }>({ visible: false, pasta: null });
    const [documentoAlterarPasta, setDocumentoAlterarPasta] = useState<{ visible: boolean, documento: Documento | null }>({ visible: false, documento: null });

    const menuPastaRef = useRef<Menu[]>([]);
    const menuDocumentoRef = useRef<Menu[]>([]);
    const { msgAlerta } = useToastContext();

    useEffect(() => {
        buscarRoot();
    }, []);

    function buscarRoot() {
        documentoPastaService.consultarRootExcluido().then((response) => {
            setPasta(response);
        }).catch((error) => {
            console.error("Erro ao buscar pasta raiz:", error);
        });
    }

    function buscarPasta(id: number) {
        documentoPastaService.consultarPastaExcluida(id).then((response) => {
            setPasta(response);
        }).catch((error) => {
            console.error("Erro ao buscar pasta:", error);
        });
    }

    const renderPastaOptions = (index: number) => {

        return [
            {
                label: 'Opções',
                items: [
                    {
                        key: `recuperar-${index}`,
                        label: 'Recuperar',
                        icon: 'pi pi-undo',
                        command: () => {
                            documentoPastaService.pastaTemMaeValida(pasta?.pastas[index].id || 0).then(data => {
                                if (data) {
                                    confirmDialog({
                                        message: 'Tem certeza que deseja restaurar esta pasta?',
                                        header: 'Confirmação',
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: "Sim",
                                        rejectLabel: "Não",
                                        accept: () => {
                                            documentoPastaService.recuperarPasta(pasta?.pastas[index].id || 0).then(() => {
                                                buscarRoot();
                                            }).catch(error => {
                                                console.error("Erro ao recuperar pasta:", error);
                                                msgAlerta("Não foi possivel recuperar a pasta", error?.data?.message || "Erro ao recuperar pasta");
                                            });
                                        }
                                    });
                                } else {
                                    confirmDialog({
                                        message: 'Esta pasta teve sua pasta mãe deletada, então irá retornar para a pasta raíz. Tem certeza que deseja restaurar esta pasta?',
                                        header: 'Confirmação',
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: "Sim",
                                        rejectLabel: "Não",
                                        accept: () => {
                                            documentoPastaService.recuperarPasta(pasta?.pastas[index].id || 0).then(() => {
                                                buscarRoot();
                                            }).catch(error => {
                                                console.error("Erro ao recuperar pasta:", error);
                                                msgAlerta("Não foi possivel recuperar a pasta", error?.data?.message || "Erro ao recuperar pasta");
                                            });
                                        }
                                    });
                                }
                            })
                        }
                    },
                    {
                        label: 'Excluir permanentemente',
                        icon: 'pi pi-trash',
                        command: () => {
                            confirmDialog({
                                message: 'Tem certeza que deseja excluir esta pasta permanentemente?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: "Sim",
                                rejectLabel: "Não",
                                accept: () => {
                                    documentoPastaService.excluirPermanentemente(pasta?.pastas[index].id || 0).then(() => {
                                        if (pasta?.id) {
                                            buscarPasta(pasta.id);
                                        } else {
                                            buscarRoot();
                                        }
                                    }).catch(error => {
                                        console.error("Erro ao excluir pasta permanentemente:", error);
                                        msgAlerta("Não foi possivel excluir a pasta", error?.data?.message || "Erro ao excluir pasta");
                                    });
                                }
                            });
                        }
                    }
                ]
            }
        ];
    }

    const renderDocumentoOptions = (index: number) => {

        return [
            {
                label: 'Opções',
                items: [
                    {
                        label: 'Recuperar',
                        icon: 'pi pi-undo',
                        command: () => {
                            documentoPastaService.documentoTemMaeValida(pasta?.documentos[index].id || 0).then(data => {
                                if (data) {
                                    confirmDialog({
                                        message: 'Tem certeza que deseja reverter este documento?',
                                        header: 'Confirmação',
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: "Sim",
                                        rejectLabel: "Não",
                                        accept: () => {
                                            documentoPastaService.recuperarDocumento(pasta?.documentos[index].id || 0).then(() => {
                                                buscarRoot();
                                            }).catch(error => {
                                                console.error("Erro ao recuperar documento:", error);
                                                msgAlerta("Não foi possivel recuperar o documento", error?.data?.message || "Erro ao recuperar documento");
                                            })
                                        }
                                    });
                                } else {
                                    confirmDialog({
                                        message: 'Este documento teve sua pasta mãe deletada, então irá retornar para a pasta raíz. Tem certeza que deseja reverter este documento?',
                                        header: 'Confirmação',
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: "Sim",
                                        rejectLabel: "Não",
                                        accept: () => {
                                            documentoPastaService.recuperarDocumento(pasta?.documentos[index].id || 0).then(() => {
                                                buscarRoot();
                                            }).catch(error => {
                                                console.error("Erro ao recuperar documento:", error);
                                                msgAlerta("Não foi possivel recuperar o documento", error?.data?.message || "Erro ao recuperar documento");
                                            })
                                        }
                                    });
                                }
                            })
                        }
                    },
                    {
                        label: 'Excluir permanentemente',
                        icon: 'pi pi-trash',
                        command: () => {
                            confirmDialog({
                                message: 'Tem certeza que deseja excluir este documento permanentemente?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: "Sim",
                                rejectLabel: "Não",
                                accept: () => {
                                    const pastaMae = pasta?.documentos[index]?.pastaMae;
                                    documentoPastaService.excluirDocumentoPermanentemente(pasta?.documentos[index].id || 0).then(() => {
                                        if (pastaMae) {
                                            buscarPasta(pastaMae.id);
                                        } else {
                                            buscarRoot();
                                        }
                                    });
                                }
                            });
                        }
                    }
                ]
            }
        ];
    }

    function buscarPastaMae(pasta: DocumentoPasta) {
        if (pasta?.pastaMae) {
            if (pasta.pastaMae.status === 'REMOVIDA') {
                buscarPasta(pasta.pastaMae.id);
            } else {
                buscarPastaMae(pasta.pastaMae);
            }
        } else {
            buscarRoot();
        }
    }

    return (
        <div>
            <ConfirmDialog />
            {pastaAlterar.visible ? <ModalDocumentoPastaEditar
                visible={pastaAlterar.visible}
                onHide={() => setPastaAlterar({ visible: false, pasta: null })}
                pasta={pastaAlterar.pasta as DocumentoPasta}
                onConfirm={() => !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            {documentoAlterarPasta.visible ? <ModalDocumentoMover
                visible={documentoAlterarPasta.visible}
                onHide={() => setDocumentoAlterarPasta({ visible: false, documento: null })}
                documento={documentoAlterarPasta.documento as Documento}
                onConfirm={() => !pasta || pasta.id == 0 ? buscarRoot() : buscarPasta(pasta.id)}
            /> : null}
            <table className="table-DocumentoPasta">
                <thead>
                    <tr>
                        <th colSpan={5} style={{ padding: "10px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", }}>
                                <div style={{ display: "flex", alignItems: "center", columnGap: "12px" }}>
                                    {pasta?.id != 0 && <Button
                                        icon="pi pi-arrow-left"
                                        onClick={() => {
                                            buscarPastaMae(pasta as DocumentoPasta);
                                        }}
                                    />}
                                    <span>{pasta?.nome}</span>
                                </div>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "50px" }}></th>
                        <th>Nome</th>
                        <th>Código</th>
                        <th>Categoria</th>
                        <th style={{ width: "50px" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {pasta?.pastas && pasta?.pastas.map((subPasta, index) => (
                        <tr key={subPasta.id} onDoubleClick={() => buscarPasta(subPasta.id)}>
                            <td style={{ width: "50px" }}>
                                <FontAwesomeIcon icon="folder" color="#2c1492" />
                            </td>
                            <td colSpan={3}>{subPasta.nome}</td>
                            <td>
                                <div className="tres-pontos" onClick={(e) => { menuPastaRef.current[index].toggle(e) }}></div>
                                <Menu model={renderPastaOptions(index)} popup ref={(ref) => menuPastaRef.current[index] = ref as Menu} id="popup_menu_left" />
                            </td>
                        </tr>
                    ))}
                    {pasta?.documentos && pasta?.documentos.map((documento, index) => (
                        <tr key={documento.id}>
                            <td>
                                <FontAwesomeIcon icon={faFile as IconLookup} color="#2c1492" />
                            </td>
                            <td>{documento.nome}</td>
                            <td>{documento.codigoInterno}</td>
                            <td>{documento.categoria?.nome}</td>
                            <td>
                                <div className="tres-pontos" onClick={(e) => { menuDocumentoRef.current[index].toggle(e) }}></div>
                                <Menu model={renderDocumentoOptions(index)} popup ref={(ref) => menuDocumentoRef.current[index] = ref as Menu} id="popup_menu_left" />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div >
    );
}